module.exports = __webpack_public_path__ + "img/vacuum_1.3104eeb3.jpg";